import React from "react"
import "./style.css"
import styled from "@emotion/styled"

const Container = styled.div`
  max-width: 940px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
`

const Layout = ({ children }) => (
    <>
        <Container>
            {children}
        </Container>
    </>
)

export default Layout